/* eslint-disable max-params */
/* eslint-disable complexity */
import { NUMBER } from "../../constants/app-constants";
import { ORDER_CATEGORY } from "../../constants/my-orders-constants";

export default (orderList, serviceType, isDesktop = false, parentCategory = "") => {
    const list = [];
    orderList.forEach((item) => {
        const orderItem = (item && item.orderItems && item.orderItems.length && item.orderItems[NUMBER.ZERO]) || {};
        if (
            (
                (orderItem.category === serviceType) ||
                serviceType === ORDER_CATEGORY.ALL ||
                !serviceType ||
                (orderItem.category === ORDER_CATEGORY.NEW_CAR_PRE_DELIVERY_INSPECTION && serviceType === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION) ||
                (orderItem.category === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION_PACKAGE && serviceType === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION) ||
                (orderItem.category === ORDER_CATEGORY.USED_CAR_INSPECTION && serviceType === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION) ||
                (orderItem.category === ORDER_CATEGORY.NEW_CAR_INSPECTION && serviceType === ORDER_CATEGORY.PRE_DELIVERY_INSPECTION) ||
                (serviceType === ORDER_CATEGORY.SELLER_PACKAGE && orderItem.category === ORDER_CATEGORY.SELLER_PACKAGE) ||
                (serviceType === ORDER_CATEGORY.SELLER_PACKAGE && (orderItem.category === ORDER_CATEGORY.SELLER_PACKAGE || orderItem.category === ORDER_CATEGORY.SELLER_PACKAGE_V2)) ||
                (serviceType === ORDER_CATEGORY.SERVICE_HISTORY && (orderItem.category === ORDER_CATEGORY.SERVICE_HISTORY_PACKAGE || orderItem.category === ORDER_CATEGORY.SERVICE_HISTORY)) ||
                (item.parentCategory === parentCategory)
            ) &&
            (!isDesktop || (orderItem.category !== ORDER_CATEGORY.CAR_HEALTH_REPORT && isDesktop))
        ) {
            list.push({
                ...item,
                regNo: orderItem.regNumber,
                category: orderItem.category,
                paymentStatus: orderItem.status
            });
        }
    });
    return {
        list
    };
};
